import { QRCodeCanvas } from "qrcode.react"
import { ButtonOutline } from "../../../Components/Screen/Button/button";

export const QrCodeNftComponent = ({ token_id, gtin }) => {
    const downloadQR = () => {
        const qrCanvas = document.getElementById("qrcode");

        // Replicate the on-screen layout: white card, 20px padding,
        // GS1 logo (150x20) on top, 20px gap, then the 150x150 QR code.
        const padding = 20;
        const gap = 20;
        const logoWidth = 150;
        const logoHeight = 20;
        const qrSize = 150;
        const contentWidth = Math.max(logoWidth, qrSize);

        const exportCanvas = document.createElement("canvas");
        exportCanvas.width = padding + contentWidth + padding;
        exportCanvas.height = padding + logoHeight + gap + qrSize + padding;
        const ctx = exportCanvas.getContext("2d");

        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);

        const triggerDownload = () => {
            const pngUrl = exportCanvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
            const downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = `qrcode-nft-${token_id}.png`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        };

        const logo = new Image();
        logo.crossOrigin = "anonymous";
        logo.onload = () => {
            // object-contain object-left: fit within the box, anchored left.
            const scale = Math.min(logoWidth / logo.width, logoHeight / logo.height);
            const drawW = logo.width * scale;
            const drawH = logo.height * scale;
            ctx.drawImage(logo, padding, padding, drawW, drawH);
            ctx.drawImage(qrCanvas, padding, padding + logoHeight + gap, qrSize, qrSize);
            triggerDownload();
        };
        logo.onerror = () => {
            // If the logo fails to load, still export the QR code.
            ctx.drawImage(qrCanvas, padding, padding + logoHeight + gap, qrSize, qrSize);
            triggerDownload();
        };
        logo.src = `${process.env.PUBLIC_URL}/GS1.png`;
    };

    return (
        <div className="w-full flex flex-col gap-4 items-center justify-center">
            <div className="bg-white flex flex-col gap-2 items-center" style={{ paddingLeft: 20, paddingRight: 20, paddingBottom: 20, paddingTop: 20 }}>
                <div className="flex flex-col" style={{ gap: 20 }}>
                <img
                    src={`${process.env.PUBLIC_URL}/GS1.png`}
                    alt="GS1"
                    style={{ width: 150 }}
                    className="h-5 object-contain object-left"
                />
                <QRCodeCanvas
                id="qrcode"
                size={150}
                includeMargin={false}
                bgColor="#ffffff"
                fgColor="#000000"
                value={process.env.REACT_APP_LOCAL_ENV === 'dev'
                    ? (gtin ? `http://localhost:3000/01/${gtin}?NFT=${token_id}` : `http://localhost:3000/nft/${token_id}`)
                    : (gtin ? `https://vinhosdobrasil.com/01/${gtin}?NFT=${token_id}` : `https://vinhosdobrasil.com/nft/${token_id}`)
                }
            />
                </div>
            </div>
            <ButtonOutline onClick={downloadQR}>Download QRCode</ButtonOutline>
        </div>
    )
}
